import React, { useState } from "react";
import { db } from "../../config/firebase";
import { doc, getDoc } from "firebase/firestore";
import { useAppState } from "../../hooks/useAppState";

const DownlodExtention = () => {
  const [loading, setLoading] = useState(false);
  const { user } = useAppState();

  const handleDownloadClick = async () => {
    setLoading(true);
    try {
      // Determine extension doc based on user role
      let extensionDoc = "user-extension";
      if (user?.role === "Expert") {
        extensionDoc = "expert-extension";
      }
      // Fetch the document from extensions/{role-extension}
      const docRef = doc(db, "extensions", extensionDoc);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        const data = docSnap.data();
        console.log(data, "Extension data fetched successfully");
        if (data.link) {
          window.open(data.link, "_blank", "noopener,noreferrer");
        } else {
          alert("Download link not found.");
        }
      } else {
        alert("Extension info not found.");
      }
    } catch (err) {
      alert("Failed to fetch extension link.");
    }
    setLoading(false);
  };

  return (
    <div>
      <div className="flex justify-between items-center bg-[#F15D180A]  p-5 rounded-[24px] mb-6 text-[#696969]">
        <span className="text-[#696969] text-[20px] nunito-medium">
          To start using supporty.io you need to download extension
        </span>
        <div className="relative group">
          <button
            className="bg-[#F15D18] text-white text-[16px] nunito-semibold px-8 py-3 rounded-[8px] hover:bg-[#F15D18]"
            onClick={handleDownloadClick}
            disabled={loading}
          >
            {loading ? "Loading..." : "Download Extension Now"}
          </button>
          {/* Tooltip on hover */}
          {/* <div className="absolute left-1/2 -translate-x-1/2 -top-8 px-2 py-1 bg-[#FAFAFA] nunito-regular text-[12px] text-[#696969] text-xs rounded-[8px] shadow-lg opacity-0 group-hover:opacity-100 pointer-events-none transition-opacity duration-200 whitespace-nowrap z-30">
            This feature is on its way - stay tuned!
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default DownlodExtention;
